import axios from "libs/axios";
import { useQuery } from "react-query";
import { TerminalDTO } from "../type";
import { AxiosError } from "axios";
import { useAppSelector } from "store";
interface terminalRequest {
  PageNumber: number;
  PageSize: number;
  AcceptorId: number;
}
const terminals = async (data: terminalRequest) => {
  return await axios
    .get<TerminalDTO>(`/api/v1/Terminal/get-by-acceptorId`, {
      params: { ...data, version: "1"  },
    })
    .then((res) => res.data)
    .catch((err) => err.data);
};

export const useTerminals = (data: Omit<terminalRequest, "AcceptorId">) => {
  const { shaparakAcceptors } = useAppSelector((state) => state.shopAndAcceptor);
  return useQuery<TerminalDTO, AxiosError>(
    [`/api/v1/Terminal/get-by-acceptorId`],
    async () =>
      terminals({
        PageNumber: data.PageNumber,
        PageSize: data.PageSize,
        AcceptorId: shaparakAcceptors?.id || 0,
      }),
    {
      enabled: !!shaparakAcceptors?.id,
    }
  );
};
